module.exports = __webpack_public_path__ + "static/img/histoire-03.ecdf030.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/histoire-03.png
// module id = 88
// module chunks = 0